import React from 'react';
import PropTypes from 'prop-types';

import styles from './CheckoutMessage.css';
import { CHECKOUT_STATUS } from '../../models/Checkout';

const IPropTypes = {
  paymentMethodId: PropTypes.number,
  status: PropTypes.string,
};

const defaultProps = {
  paymentMethodId: 0,
  status: '',
};

const CheckoutMessage = (props) => {
  if ([CHECKOUT_STATUS.PENDING, CHECKOUT_STATUS.PENDING_PAYMENT,
    CHECKOUT_STATUS.REJECT_PAYMENT, CHECKOUT_STATUS.DISABLED].includes(props.status) &&
     props.paymentMethodId !== 1 && props.paymentMethodId !== 3
  ) {
    return (
      <div className={styles.container}>
        <p>Lamentamos que tu pago no haya podido ser realizado.</p>
        <p>Te invitamos a volver a agregar tus productos al carrito y
          probar realizar nuevamente el pago.
        </p>
        <p>¡Gracias por tu confianza!</p>
      </div>
    );
  }
  // Efectivo
  if (props.paymentMethodId === 1 || props.paymentMethodId === 3) {
    return (
      <div className={styles.container}>
        <p>¡Muchas gracias por tu compra!</p>
        <p>
          Tu pedido está siendo verificado y lo confirmaremos a la máxima brevedad
          posible (en horario laboral) y allí recibirás un mail con los detalles de tu compra.
        </p>
        <p>También podrás ver el estado de tu pedido en Mi cuenta / Mis compras.</p>
        <p>Finalmente, el pago deberás realizarlo en efectivo al momento de recibir tu compra.</p>
        <p>¡Gracias nuevamente por tu confianza!</p>
      </div>
    );
  }
  // Pago con banco
  if (props.paymentMethodId === 4) {
    return (
      <div className={styles.container}>
        <p>¡Muchas gracias por tu compra!</p>
        <p>
        Tu pedido está confirmado. En unos minutos recibirás un mail con los detalles de tu compra.
        </p>
        <p>También podrás ver el estado de tu pedido en Mi cuenta / Mis compras.</p>
        <p>¡Gracias nuevamente por tu confianza!</p>
      </div>
    );
  }
  // Pago con red pago y abitab
  if (props.paymentMethodId === 5) {
    return (
      <div className={styles.container}>
        <p>¡Muchas gracias por tu compra!</p>
        <p>Ya podés ir a un Abitab o Redpagos a realizar el pago, considerando: </p>
        <ul>
          <li>Hacer el pago para Carlos Gutiérrez SA.</li>
          <li>Concurrir con el documento con el que hiciste la compra.</li>
        </ul>
        <p>
          Luego de recibir el pago, nosotros confirmaremos la recepción a la máxima
          brevedad posible (en horario laboral) y allí recibirás un mail con los
          detalles de tu compra.
        </p>
        <p>También podrás ver el estado de tu pedido en Mi cuenta / Mis compras.</p>
        <p>¡Gracias nuevamente por tu confianza!</p>
      </div>
    );
  }
  return null;
};

CheckoutMessage.propTypes = IPropTypes;
CheckoutMessage.defaultProps = defaultProps;

export { CheckoutMessage };



// WEBPACK FOOTER //
// ./src/common/checkout-message/CheckoutMessage.jsx